import * as React from "react";
import Header from "../components/header";
import Slider from "../components/slider";

import info from "../info.json";
import { animate, motion, scroll } from "framer-motion";
import { useStaticQuery, graphql } from "gatsby";
import { IconMouse } from "@tabler/icons-react";

import InfoPopUp from "../components/info-popup";
import Form from "../components/form";
import Seo from "../components/seo";
import { StaticImage } from "gatsby-plugin-image";

export default function IndexPage({ data }) {
  const [visible, setVisible] = React.useState(false);
  const [visibleInfo, setVisibleInfo] = React.useState(false);
  const [currentNumber, setCurrentNumber] = React.useState(1);

  const productsList =
    data.wpCategory.flowers.nodes.length >= 7
      ? [...data.wpCategory.flowers.nodes]
      : [...data.wpCategory.flowers.nodes, ...data.wpCategory.flowers.nodes];
  var boolInfo = data.wpPage.moreAbout != undefined ? true : false;

  React.useEffect(() => {
    const hero = document.getElementById("hero-video");

    let movement = 1;

    let boolWheel = false;
    document.addEventListener("wheel", () => {
      if (boolWheel === false) {
        // animate(
        //   hero,
        //   {
        //     transform: ["translate(0px, 0px)", "translate(0px, -100vh)"],
        //     opacity: [100, 100],
        //   },
        //   { duration: 2 },
        //   { type: "spring" }
        // );
        // boolWheel = true;
      }
    });

    function handleswipe(isUpSwipe) {
      // if (isUpSwipe && boolWheel === false) {
      //   animate(
      //     hero,
      //     {
      //       transform: ["translate(0px, 0px)", "translate(0px, -100vh)"],
      //       opacity: [100, 100],
      //     },
      //     { duration: 1.5 },
      //     { type: "spring" }
      //   );
      //   boolWheel = true;
      // }
    }

    var startX,
      startY,
      dist,
      threshold = 150, //required min distance traveled to be considered swipe
      allowedTime = 200, // maximum time allowed to travel that distance
      elapsedTime,
      startTime;

    document.addEventListener(
      "touchstart",
      function (e) {
        var touchobj = e.changedTouches[0];
        dist = 0;
        startX = touchobj.pageX;
        startY = touchobj.pageY;
        startTime = new Date().getTime(); // record time when finger first makes contact with surface
        e.preventDefault();
      },
      false
    );

    document.addEventListener(
      "touchmove",
      function (e) {
        e.preventDefault(); // prevent scrolling when inside DIV
      },
      false
    );

    document.addEventListener(
      "touchend",
      function (e) {
        var touchobj = e.changedTouches[0];
        dist = touchobj.pageY - startY; // get total dist traveled by finger while in contact with surface
        elapsedTime = new Date().getTime() - startTime; // get time elapsed
        // check that elapsed time is within specified, horizontal dist traveled >= threshold, and vertical dist traveled <= 100
        var swipeerUpBool =
          elapsedTime <= allowedTime &&
          dist < threshold &&
          Math.abs(touchobj.pageX - startX) <= 100;
        handleswipe(swipeerUpBool);
        e.preventDefault();
      },
      false
    );

    // document.removeEventListener('wheel', moveHero(hero))

    // transform: ["none", "translateY(-100%)"],
    // scroll(
    //   // animate(hero, { opacity: [100, 0]}, {duration: 1})
    // )
  });

  return (
    <main className="flex flex-col relative overflow-hidden h-[100dvh]">
      {/* <div className="absolute flex justify-center items-center z-[200] w-full h-full flex-col hidden">
        <div className="text-white mb-16">
          <h3>ROYAL FLOWERS</h3>
        </div>
        <div className="uppercase flex text-7xl justify-center items-center md:mr-[80px] md:mb-[100px] text-white px-8 md:px-0">
          <span className="-mr-[30px] text-4xl md:text-9xl">Coming</span>

          <StaticImage
            src="../images/clock.png"
            placeholder="none"
            className="max-h-[600px] max-w-[600px]"
          />

          <span className="text-4xl md:text-9xl">Soon</span>
        </div>
      </div>
      <div className="bg-black text-white absolute w-[100vw] p-8 h-[100vh] z-[150] flex flex-col items-center justify-between hidden">
        <div className="flex w-full justify-between text-xl">
          <p>premium flowers</p> <p>est. 1991</p>
        </div>

        <div className="flex w-full justify-between text-xl">
          <p>@royalflowersgroup</p> <p>We Speak Flowers</p>
        </div>
      </div> */}

      {boolInfo && (
        <InfoPopUp
          visibleInfo={visibleInfo}
          setVisibleInfo={setVisibleInfo}
          type="Homepage"
          currentPage={"Red Roses Collection"}
          moreAbout={data.wpPage.moreAbout}
        />
      )}
      <Form
        visible={visible}
        setVisible={setVisible}
        type="Homepage"
        currentPage={"Red Roses Collection"}
      />
      <Header />


      <Slider
        isHome={true}
        productsList={productsList}
        boolInfo={boolInfo}
        visibleInfo={visibleInfo}
        setVisibleInfo={setVisibleInfo}
        visible={visible}
        setVisible={setVisible}
        collection={"Red Roses Collection"}
        sliderLength={productsList.length}
        catalog={data.wpPage.homepage.catalog}
      />
    </main>
  );
}

export function Head({ data }) {
  const {
    wpPage: { seo },
  } = data;

  return (
    <Seo
      title={seo.title}
      description={seo.metaDesc}
      url={data.site.siteMetadata.siteUrl}
    >
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Royal Flowers Group",
          alternateName: "Royal Flowers",
          url: "https://royalflowersgroup.com/",
          logo: "https://royalflowersgroup.com/static/c6a2525c548497900abc3c32b3143498/c6160/logo-royal-flower.webp",
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "(305) 477 4483",
            contactType: "customer service",
            areaServed: ["US", "GB", "CA"],
            availableLanguage: "en",
          },
          sameAs: [
            "https://www.facebook.com/Royalflowersgroup/",
            "https://www.linkedin.com/company/royal-flowers-group/",
            "https://www.instagram.com/royalflowersgroup/",
            "https://www.linkedin.com/company/royal-flowers-group/",
            "https://www.youtube.com/user/Royalflowersecuador",
          ],
        })}
      </script>
    </Seo>
  );
}

export const query = graphql`
  query HomePage {
    site {
      siteMetadata {
        siteUrl
      }
    }
    wpCategory(name: { eq: "Homepage" }) {
      slug
      name
      flowers {
        nodes {
          slug
          title
          featuredImage {
            node {
              gatsbyImage(width: 700, height: 1100)
            }
          }
          categories {
              nodes {
                  name
                  slug
              }
          }
          flowerExtraFields {
            color
            isNew
          }
        }
      }
    }
    wpPage(title: { eq: "Home" }) {
      seo {
        title
        metaDesc
        canonical
      }
      homepage {
        catalog
        videoYoutubeLink {
          url
        }
      }
      moreAbout {
        moretext
        moretitle
      }
    }
  }
`;
